import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';

@Component({
  selector: 'app-authoring-activated-course',
  templateUrl: './authoring-activated-course.component.html',
  styleUrls: ['./authoring-activated-course.component.scss']
})
export class AuthoringActivatedCourseComponent implements OnInit {
  errorInfo: { isError: boolean, errorMsg: string } = { isError: false, errorMsg: '' }
  userCourseList: any[]=[];contentDetailsData:any;contentDetailsMediaData:any=[];
  userDetail: any;
  userID:any;
  adminData: any;
  content_capsule_ids:any='';
  searchText: string="";
  closeResult: any = '';
  order_by = "asc"; order:any;
  capsuleId:any; isActive:any=1
  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService,
    private route: ActivatedRoute,
    private router: Router, private spinner: NgxSpinnerService) { 
      if (localStorage.getItem('adminData') =='' || localStorage.getItem('adminData') == null) {
        this.router.navigateByUrl('/admin-login');
      }
    }
    ngOnInit(): void {
      this.adminData=JSON.parse(localStorage.getItem('adminData') || '[]');
      this.route.queryParams.subscribe(params => {
        const id = +params.id;
        if (id > 0) {
         this.capsuleId=id;
      }
      this.userID = this.adminData.user_id;
      this.getUserDetail(this.userID);
      this.getContentAuthDetails(this.capsuleId);
      this.getUserCourseList(this.capsuleId, this.searchText, this.order, this.order_by, this.isActive);
    });
    }
    getContentAuthDetails(content_capsule_id:any){
      this.spinner.show();
      this.contentAuthoringApi.getContentAuthDetails(content_capsule_id).subscribe(
        (data)=>{
        if(data.success){
          this.spinner.hide();
          this.contentDetailsData=data.data; 
          this.contentDetailsMediaData=data.data.contentCapsuleMedia; 
         // console.log(this.contentDetailsData);
        }else{
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
        },
        (error) => {
          this.spinner.hide();
          this.errorInfo.errorMsg = error;
         },
      );
    }
   /*get user course list data********/
   getUserCourseList(capsuleId:any, searchText:any, order:any, order_by:any, isActive:any) {
    this.spinner.show();
    this.contentAuthoringApi.getActivateDeactiveCourseList(capsuleId,searchText, order,order_by, isActive).subscribe(
      (data) => {
        if (data.status == true) {
          this.spinner.hide();
          this.userCourseList = data.user_course_list;
          // console.log(this.userData);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  getUserDetail(userID:any) {
    this.spinner.show();
    this.contentAuthoringApi.getUserDetail(userID).subscribe(
      (data) => {
        this.userDetail=data.userList;
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  search(event: any) {
    this.searchText = event.target.value;
    this.getUserCourseList(this.capsuleId, this.searchText, this.order, this.order_by, this.isActive);
  }
  getMediaType(mediatypeArr:any,media_type:any){
    const checkMediType = (obj: { media_type: string; }) => obj.media_type == media_type;
    return mediatypeArr.some(checkMediType);
    
  }
  open(content: any,content_capsule_id:any) {
    //this.tabName = tab_name;
    this.content_capsule_ids = content_capsule_id;
    this.modalService.open(content, { size: 'sm',centered: true  }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    //this.succesDelAssessment = false;
    //.activeDleMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = 'desc'; this.order = sort.active;
    } else if (sort.direction == 'asc') {
      this.order_by = 'asc'; this.order = sort.active;
    } else { this.order_by = 'created_dttm'; this.order = 'desc'; }
    // this.courseList(this.course_name, this.is_active, this.course_status, this.order_by, this.order);
    this.getUserCourseList(this.capsuleId, this.searchText, this.order, this.order_by, this.isActive);
  }
  changeIsDeActiveVal(capsule_id: any,is_actives:any) {
    this.changeIsActiveVal(capsule_id,is_actives);
   }
   changeIsActiveVal(content_capsule_id: any,is_active:any){
    this.contentAuthoringApi.changeIsActiveVal(content_capsule_id,is_active).subscribe(
      (data)=>{
       // console.log(data);
        if(data.status == 200){
          document.getElementById('closelId')?.click();
          this.getContentAuthDetails(this.content_capsule_ids);
          //this.router.navigate(['/authoring_viewContent'], { queryParams: { id: this.content_capsule_ids } });
        }else{
        this.errorInfo.isError = true;
        this.errorInfo.errorMsg = 'No data Exist'
      }
      },
      (error) => { 
        this.errorInfo.errorMsg = error;
       },
    );
  }
  duplicateCapsule(capsule_id: any) {
    this.spinner.show();
    this.contentAuthoringApi.getContentAuthDetails(capsule_id).subscribe(
      (data) => {
        if (data.status == 200) {
          this.contentDetailsData = data.data;
          this.contentDetailsData['capsule_name'] = this.contentDetailsData.capsule_name + '-copy';
          this.contentDetailsData['capsules_status'] = 1;
          delete this.contentDetailsData['content_capsule_id'];
          this.contentDetailsData['created_by']='1';
          delete this.contentDetailsData['created_dttm'];
          // if(tab_name =='Deactivated'){
          //   this.contentDetailsData['is_active'] = 0;
          // }
           let arr = this.contentDetailsData.contentCapsuleMedia;
           for (let n = 0; n < arr.length; n++) {
             
            if(arr[n]['media_type'] === 2 ){
              this.toDataURL(arr[n]['media_path'], function (dataURL: any) {
                arr[n]['media_path'] = dataURL;
              });
           } 
           if(arr[n]['media_type'] === 3 ){
            this.toDataURL(arr[n]['media_path'], function (dataURL: any) {
              arr[n]['media_path'] = dataURL;
            });
          }
            delete arr[n]['content_capsule_id'];
            delete arr[n]['created_by'];
            delete arr[n]['created_dttm'];
            delete arr[n]['content_capsule_media_id'];
            delete arr[n]['modified_dttm'];
            delete arr[n]['sort_order'];
            delete arr[n]['is_active'];
           }
          setTimeout(() => {
          this.saveDuplicateCapsule(this.contentDetailsData);
          }, 10000);
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
  toDataURL(src: any, callback: any) {
    let xhttp = new XMLHttpRequest();
    xhttp.onload = function () {
      let fileReader = new FileReader();
      fileReader.onloadend = function () {
        callback(fileReader.result);
      }
      fileReader.readAsDataURL(xhttp.response);
    }
    xhttp.responseType = 'blob';
    xhttp.open('GET', src, true);
    xhttp.send();
  }
  saveDuplicateCapsule(contentAuthForm: any) {
    this.spinner.show();
    this.contentAuthoringApi.upload(contentAuthForm,'create').subscribe(
      (data) => {
        if (data.status == 201 || data.status == 200) {
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.errorInfo.isError = true;
          this.errorInfo.errorMsg = 'Something went wrong.'
        }
      },
      (error) => {
        this.spinner.hide();
        this.errorInfo.errorMsg = error;
      },
    );
  }
}
